import React from 'react'
import { BagCrossBroken } from 'solar-icons'

import { Hint } from '@/components/ui'

export const CartPlaceholder = ({
  description,
  title,
}: {
  description?: string
  title?: string
}) => {
  return (
    <div className="inline-flex flex-col items-center justify-center gap-4 rounded-lg px-5 py-5 md:py-10 lg:px-20 lg:py-0">
      <BagCrossBroken className="size-20 text-gray-200" strokeWidth={0.6} />
      <div className="flex flex-col items-center gap-2 text-center">
        <span className="text-base font-medium">{title ?? 'No Products'}</span>
        <Hint>
          {description ?? 'Add products to your cart and they will appear here'}
        </Hint>
      </div>
    </div>
  )
}
